export function getDeviationPrice(deviation) {
    var dollarsPrice;
    var pointsPrice;
    if (deviation.commission) {
        dollarsPrice = deviation.commission.dollarsCost;
        pointsPrice = deviation.commission.pointsCost;
    }
    else if (deviation.pcp) {
        dollarsPrice = deviation.pcp.downloadDollarPrice;
        pointsPrice = deviation.pcp.downloadPrice;
    }
    return { dollarsPrice: dollarsPrice, pointsPrice: pointsPrice };
}
//# sourceMappingURL=helpers.js.map